module.exports = __webpack_public_path__ + "img/slide_1.b30721f7.jpg";